module.exports = "{{#each columns}} <div class=grid-header-column> <div class=grid-header-column-content-view></div> <div class=grid-header-dragger></div> </div> {{/each}}";


//////////////////
// WEBPACK FOOTER
// ../src/nativeGrid/templates/header.hbs
// module id = 713
// module chunks = 0